import { Component, OnInit } from '@angular/core';
import { Http } from "@angular/http";
import { Router }  from '@angular/router';
import { Member } from '../member/member';
import { MemberService } from '../member/member.service';
import * as firebase from 'firebase';

/**
 * Modules
 */
import { AlertModule } from 'ng2-bootstrap';

//import {DataTableModule} from "angular2-datatable";

@Component({
  selector: 'cef-memberList',
  templateUrl: './memberList.component.html'
})

export class MemberlistComponent implements OnInit {
	public currUser;
	public data = new Array();
	public allUsers;
	public unitOption = new Array();
	//public tutorOption = new Array();
    public filterQuery = "";
    public emailQuery = "";
    public unitQuery = "";
    public levelQuery = "";
	//public tutorQuery = "";
	public rankList = [];

    public rowsOnPage = 10;
	public sortBy = "email";
	public rankSortBy = "score";
	public sortOrder = "asc";
	public rankSortOrder = "desc";

	public statistic

    dataIndex = 0;

    editMsg = '';
    editUid = '';
    editCredential = {
    	oldEmail:'',
    	email:'',
    	password:''
    }

    editProfile = {
    	name:'',
    	dateOfBirth:'',
    	gender:'',
    	level:5,
    	unit:'',
		group:'',
    	created: '',
		createdBy: '',
		modified: '',
		modifiedBy: ''
    }  


	constructor(private http: Http, private router: Router, private memberService: MemberService) {
		
	}

	ngOnInit(): void {
		let db = firebase.database();

		firebase.auth().onAuthStateChanged((user:any) => {
		  if (user) {
		    this.currUser = user;
		  }
		});
		
	    db.ref('profile/').once('value').then(
			(snapshot:any) => {
				if (snapshot.val()){
					this.dataIndex = 0;
					let returnVal = snapshot.val();
					this.allUsers = snapshot.val();
					if (returnVal[this.currUser.uid].level > 1){
						//not allow to enter
						if (returnVal[this.currUser.uid].level== 2 || returnVal[this.currUser.uid].level == 3) {
                            this.router.navigate(['/webadmin/message']);
                        } else {
                            this.router.navigate(['/member/dashboard']);
                        }
					}
					for(let uid of Object.keys(returnVal)){	
						returnVal[uid].uid = uid;
						returnVal[uid].created = new Date(returnVal[uid].created);
						this.data.push(returnVal[uid]);
						this.http.get(this.memberService.EBURL+"getMemberInfo/"+uid+"/"+this.dataIndex).subscribe((res:any)=> {
							res = res.json();
							//this.data[res.dataIndex].id =uid;
							this.data[res.dataIndex].email = res.email;
							this.data[res.dataIndex].emailVerified = res.emailVerified;
							this.data[res.dataIndex].disabled = res.disabled;
			            });
			            if (this.unitOption.indexOf(returnVal[uid].unit)==-1 && returnVal[uid].unit){
			            	this.unitOption.push(returnVal[uid].unit);
			            }
			            //if (this.tutorOption.indexOf(returnVal[uid].tutor)==-1 && returnVal[uid].tutor){
			            //	this.tutorOption.push(returnVal[uid].tutor);
			            //}
			            this.dataIndex++;
					}
				}
				// update email info

			}
		)
	}
	
	showStatistic(){
		this.statistic = {
			'numOfMale':0,
			'numOfFemale':0,
			'monthCreated':[0,0,0,0,0,0,0,0,0,0,0,0],
			'monthName':['','','','','','','','','','','',''],
			'existUnit':{},
			'numOfUnit':0,
			'numOfCreated':0,
			'level':[0,0,0,0,0,0],
			//e.g. grp0: unknown, grp11:4-6..etc grp5:>16
			'ageGroup':{'grp0':0,'grp1':0,'grp2':0,'grp3':0,'grp4':0,'grp5':0,'grp6':0}
		}
		var today = new Date()
		var thisYr = today.getFullYear()
		var thisMonth = today.getMonth()
		for(var uid in this.allUsers){
			if (this.allUsers[uid].created){
				var createdDateTime = new Date(this.allUsers[uid].created)
				var monthDiff = (createdDateTime.getFullYear()-thisYr)*12 + createdDateTime.getMonth()-thisMonth
				if (monthDiff > -11) {
					this.statistic.monthCreated[monthDiff*-1] += 1
					var monthName = new Date()
					monthName.setMonth(monthName.getMonth() + monthDiff)
					this.statistic.monthName[monthDiff*-1] = monthName.toDateString()
				}
				this.statistic.numOfCreated += 1
			}
			if (this.allUsers[uid].gender){
				if (this.allUsers[uid].gender=='男') this.statistic.numOfMale += 1
				if (this.allUsers[uid].gender=='女') this.statistic.numOfFemale += 1	
			}
			if (this.allUsers[uid].unit){
				if (this.statistic.existUnit[this.allUsers[uid].unit]===undefined) {
					this.statistic.existUnit[this.allUsers[uid].unit] = {'members':0}
					this.statistic.numOfUnit += 1
				}
				this.statistic.existUnit[this.allUsers[uid].unit].members += 1
			}
			if (this.allUsers[uid].level){
				this.statistic.level[this.allUsers[uid].level] += 1
			}
			if (this.allUsers[uid].dateOfBirth){
				var yrOfBirth = new Date(this.allUsers[uid].dateOfBirth).getFullYear()
				var thisYr = new Date().getFullYear()
				if (yrOfBirth==1900){
					this.statistic.ageGroup.grp0 += 1 //unknown
				} else {
					var age = thisYr-yrOfBirth
					if (age < 8) this.statistic.ageGroup.grp1 += 1
					if (age >= 8 && age < 10) this.statistic.ageGroup.grp2 += 1
					if (age >= 10 && age < 12) this.statistic.ageGroup.grp3 += 1
					if (age >= 12 && age < 14) this.statistic.ageGroup.grp4 += 1
					if (age >= 14 && age < 16) this.statistic.ageGroup.grp5 += 1
					if (age >= 16) this.statistic.ageGroup.grp6 += 1
				}
			}
		}
		console.log(this.statistic)
	}

	hallOfFrame(){
		this.rankList = []
		var db = firebase.database();
		db.ref('awards').once('value').then(
			(awards:any) => {
				var updatedAwards = awards.val()
				for (var uid in updatedAwards){
					var retTaskAwards = {
						name:'',
						unit:'',
						score:0,
						progress:{
							newMember:[],
							journey:{},
							joy:{}
						},
						awards:{
							login:0,
							journey:0,
							joy:0,
							newMember:false
						}
					}
					
					retTaskAwards.name = this.allUsers[uid].name;
					retTaskAwards.unit = this.allUsers[uid].unit;

					if (updatedAwards[uid].login) {
						//retTaskAwards.progress.newMember.push('login');
						retTaskAwards.awards.login = updatedAwards[uid].login.length-1;
						retTaskAwards.score += updatedAwards[uid].login.length-1
					}
					//if (updatedAwards[uid].updateProfile) retTaskAwards.progress.newMember.push('updateProfile');
					//if (updatedAwards[uid].viewWebGuide) retTaskAwards.progress.newMember.push('viewWebGuide');
					//if (updatedAwards[uid].viewSpritJoyGuide) retTaskAwards.progress.newMember.push('viewWebGuide');
					if (retTaskAwards.progress.newMember.length==4) {
						retTaskAwards.awards.newMember = true;
						retTaskAwards.score += 1
					}
					
					//check other awards
					if (updatedAwards[uid].readJourney) {
						retTaskAwards.awards.journey = updatedAwards[uid].readJourney.length-1;
						retTaskAwards.score += retTaskAwards.awards.journey
					}
					if (updatedAwards[uid].readSpritJoy) {
						retTaskAwards.awards.joy = updatedAwards[uid].readSpritJoy.length-1;
						retTaskAwards.score += retTaskAwards.awards.joy
					}
					this.rankList.push(retTaskAwards);
				}
			}
		)
	}

    newMember(){
	    this.editCredential = {
	    	oldEmail:'',
	    	email:'',
	    	password:''
	    }

	    this.editProfile = {
	    	name:'',
	    	dateOfBirth:'',
	    	gender:'',
	    	level:5,
	    	unit:'',
			group:'',
	    	created: '',
    		createdBy: '',
    		modified: '',
    		modifiedBy: ''
	    }      	
    }

    editMember(uid:string){
    	//console.log(this.memberService.EBURL);
    	this.editMsg = '';
    	this.editUid = uid;
    	this.editCredential = {oldEmail:'', email:'',password:''}
		this.editProfile = {name:'',dateOfBirth:'',gender:'',level:5,unit:'',group:'',created: '',createdBy: '',modified: '',modifiedBy: ''}
		for (let entry of this.data) {
		    if (entry.uid == uid){
		    	this.editProfile = {
		    		name:entry.name,
			    	dateOfBirth: entry.dateOfBirth,
			    	gender: entry.gender,
			    	level: entry.level,
			    	unit: entry.unit,
					group:entry.group,
			    	created: entry.created,
    				createdBy: entry.createdBy,
    				modified: (new Date()).toString(),
    				modifiedBy: uid
		    	}
		    	this.editCredential.email = entry.email;
		    	this.editCredential.oldEmail = entry.email;
		    	break;
		    }
		}
    }

    saveMember(uid:string){
    	if (this.editCredential.email != this.editCredential.oldEmail){
    		this.http.get(this.memberService.EBURL+"updateMemberEmail/"+uid+"/"+this.editCredential.email).subscribe((res:any)=> {
				res = res.json();
				if (res.code){
					this.editMsg = res.message;
					setTimeout(()=>{this.editMsg = '';},this.memberService.modalDismiss);
				} else {
					for (let i=0; i<this.data.length;i++){
						if (this.data[i].uid==uid){
							this.data[i].email = this.editCredential.email;
							break;
						}
					}
					this.editMsg = '檔案已更新！';
					setTimeout(()=>{this.editMsg = '';},this.memberService.modalDismiss);
				}
            });
    	}
    	if (this.editCredential.password.trim()){
    		this.http.get(this.memberService.EBURL+"updateMemberPwd/"+uid+"/"+this.editCredential.password).subscribe((res:any)=> {
				res = res.json();
				if (res.code){
					this.editMsg = res.message;
					setTimeout(()=>{this.editMsg = '';},this.memberService.modalDismiss);
				} else {
					this.editMsg = '檔案已更新！';
					setTimeout(()=>{this.editMsg = '';},this.memberService.modalDismiss);
				}
            });
    	}
    	let db = firebase.database();
    	this.editProfile.name = this.editProfile.name?this.editProfile.name:'';
    	this.editProfile.unit = this.editProfile.unit?this.editProfile.unit:'';
    	this.editProfile.group = this.editProfile.group?this.editProfile.group:'';
    	this.editProfile.created = this.editProfile.created?this.editProfile.created:'';
    	this.editProfile.createdBy = this.editProfile.createdBy?this.editProfile.createdBy:'';
    	this.editProfile.name = this.editProfile.name.trim();
    	this.editProfile.unit = this.editProfile.unit.trim();
    	//this.editProfile.tutor = this.editProfile.tutor.trim();
    	db.ref('profile/' + uid).update({
		    		name: this.editProfile.name,
			    	dateOfBirth: this.editProfile.dateOfBirth?this.editProfile.dateOfBirth:'',
			    	gender: this.editProfile.gender?this.editProfile.gender:'',
			    	level: this.editProfile.level?this.editProfile.level:5,
			    	unit: this.editProfile.unit,
					group: this.editProfile.group,
			    	created: this.editProfile.created,
    				createdBy: this.editProfile.createdBy,
    				modified: (new Date()).toString(),
    				modifiedBy: uid
		}).then(
			result => {
				for (let i=0; i<this.data.length;i++){
						if (this.data[i].uid==uid){
							this.data[i].name = this.editProfile.name;
					    	this.data[i].dateOfBirth = this.editProfile.dateOfBirth?this.editProfile.dateOfBirth:'';
					    	this.data[i].gender = this.editProfile.gender?this.editProfile.gender:'';
					    	this.data[i].level = this.editProfile.level?this.editProfile.level:5;
					    	this.data[i].unit = this.editProfile.unit;
					    	this.data[i].group = this.editProfile.group;

					    	//if (this.tutorOption.indexOf(this.editProfile.tutor)==-1 && this.editProfile.tutor){
				            //	this.tutorOption.push(this.editProfile.tutor);
				            //}
				            if (this.unitOption.indexOf(this.editProfile.unit)==-1 && this.editProfile.unit){
				            	this.unitOption.push(this.editProfile.unit);
				            }
							break;
						}
					}
				this.editMsg = '檔案已更新！';
				setTimeout(()=>{this.editMsg = '';},this.memberService.modalDismiss);
			}
		).catch(
			(error:any) => {
				this.editMsg = error.code;
				setTimeout(()=>{this.editMsg = '';},this.memberService.modalDismiss);
			}
		);
    	
    }

     saveNewMember(isSaveNew:boolean){
     	if (!this.editCredential.email || !this.editCredential.password){
     		this.editMsg = '必需有電郵和密碼！';
     		setTimeout(()=>{this.editMsg = '';},this.memberService.modalDismiss);
     		return
     	}

     	this.editProfile.name = this.editProfile.name?this.editProfile.name:'';
    	this.editProfile.unit = this.editProfile.unit?this.editProfile.unit:'';
    	this.editProfile.group = this.editProfile.group?this.editProfile.group:'';
    	this.editProfile.name = this.editProfile.name.trim();
    	this.editProfile.unit = this.editProfile.unit.trim();
    	this.editProfile.group = this.editProfile.group.trim();

    	if (this.editCredential.email && this.editCredential.password){
    		this.http.get(this.memberService.EBURL+"addMember/"+this.editCredential.email+"/"+this.editCredential.password).subscribe((res:any)=> {
				res = res.json();
				if (res.code){
					this.editMsg = res.message;
					setTimeout(()=>{this.editMsg = '';},this.memberService.modalDismiss);
				} else if (res.uid) {
					let db = firebase.database();
					db.ref('profile/' + res.uid).set({
			    		name: this.editProfile.name,
				    	dateOfBirth: this.editProfile.dateOfBirth?this.editProfile.dateOfBirth:'',
				    	gender: this.editProfile.gender?this.editProfile.gender:'',
				    	level: this.editProfile.level?this.editProfile.level:5,
				    	unit: this.editProfile.unit,
				    	group: this.editProfile.group,
				    	created: (new Date()).toString(),
	    				createdBy: this.currUser.uid,
	    				modified: (new Date()).toString(),
	    				modifiedBy: this.currUser.uid
					}).then(
						result => {
							this.data.push({
								uid: res.uid,
								name: this.editProfile.name,
								email: this.editCredential.email,
						    	dateOfBirth: this.editProfile.dateOfBirth?this.editProfile.dateOfBirth:'',
						    	gender: this.editProfile.gender?this.editProfile.gender:'',
						    	level: this.editProfile.level?this.editProfile.level:5,
						    	unit: this.editProfile.unit,
						    	group: this.editProfile.group
							});
							//if (this.tutorOption.indexOf(this.editProfile.tutor)==-1 && this.editProfile.tutor){
				            //	this.tutorOption.push(this.editProfile.tutor);
				            //}
				            if (this.unitOption.indexOf(this.editProfile.unit)==-1 && this.editProfile.unit){
				            	this.unitOption.push(this.editProfile.unit);
				            }
							this.editMsg = '已新增會員！';
							setTimeout(()=>{this.editMsg = '';},this.memberService.modalDismiss);
							if (!isSaveNew){
								this.editCredential = {oldEmail:'',email:'',password:''}
								this.editProfile = {name:'',dateOfBirth:'',gender:'',level:5,unit:'',group:'',created: '',createdBy: '',modified: '',modifiedBy: ''}
							}
						}
					).catch(
						(error:any) => {
							this.editMsg = error.message;
							setTimeout(()=>{this.editMsg = '';},this.memberService.modalDismiss);
						}
					);
				}
            });
    	}

    }

    disableMember(uid:string){
		this.editUid = uid;
		this.http.get(this.memberService.EBURL+"disableMember/"+uid).subscribe((res:any)=> {
			res = res.json();
			if (res == 'success'){
				//update records
				for (let i=0; i<this.data.length;i++){
					if (this.data[i].uid==this.editUid){
						this.data[i].disabled = true;
						break;
					}
				}
			}
        });
    }

    enableMember(uid:string){
		this.editUid = uid;
		this.http.get(this.memberService.EBURL+"enableMember/"+uid).subscribe((res:any)=> {
			res = res.json();
			if (res == 'success'){
				for (let i=0; i<this.data.length;i++){
					if (this.data[i].uid==this.editUid){
						this.data[i].disabled = false;
						break;
					}
				}
			}
        });
	}

}



// WEBPACK FOOTER //
// C:/Users/noomo/Desktop/project/newCefKid/cefapp2/src/app/webadmin/memberList.component.ts